var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-down"}},[(_vm.displayHeader)?_c('header',{key:"site-header",staticClass:"site-header"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/img/mychapman-logo.svg"),"alt":"MyChapman"}}),_c('UserMenu',{staticClass:"user-menu"})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }